import { useAuth } from '../contexts/auth-context'
import type { UserRole } from '../types/auth.types'

/**
 * Hook to access firm context from JWT claims.
 * Returns firm_id and user_role for the current authenticated user.
 */
export function useFirm() {
  const { firmId, userRole, isAuthenticated } = useAuth()

  /** Check if user has specific role */
  const hasRole = (role: UserRole): boolean => {
    return userRole === role
  }

  /** Check if user has at least manager role (manager or partner) */
  const isManagerOrAbove = (): boolean => {
    return userRole === 'manager' || userRole === 'partner'
  }

  /** Check if user is partner */
  const isPartner = (): boolean => {
    return userRole === 'partner'
  }

  return {
    firmId,
    userRole,
    isAuthenticated,
    hasRole,
    isManagerOrAbove,
    isPartner
  }
}
